import React, { useEffect, useState } from 'react'
import { INPUT_TYPE } from '../../models/form'
import FormInput from '../form/FormInput'
import styles from './FiltersBar.module.scss'
import LuxButton from '../buttons/Button'
import { LuxFormDialog, LuxFormInput } from '../../Techedge-Wardrobe'

const FiltersBar = (props: {
    filters: any
    filtersList: any
    clearFilters?
    labels?: {
        clearFilters?: string
        addFavourite?: string
        updateFavourite?: string
        favouriteName?: string
    }
    colWidth?: number
    favouriteFilter?: {
        addFavourite: (name: string) => void
        selectedFavourite: string
        favouriteFilters?: { label: string; filters: any }[]
        applyFavourite: (name: string) => void
        deleteFavourite: (name: string) => void
    }
    onFiltersBarChange?: (e: any, filter: any) => void
    clearFiltersVisibility?: boolean
}) => {
    const {
        filters,
        filtersList,
        clearFilters,
        labels,
        favouriteFilter,
        colWidth,
        onFiltersBarChange,
        clearFiltersVisibility,
    } = props

    const [isFiltersDivisible, setIsFiltersDivisible] = useState(0)
    const [modalOpen, setModalOpen] = useState<boolean>(false)
    const [newFavName, setNewFavName] = useState<string>('')
    const [selectedFav, setSelectedFav] = useState('')

    const activeDates = {
        start: filters?.start_date ? new Date(filters.start_date) : undefined,
        end: filters?.end_date ? new Date(filters.end_date) : undefined,
    }

    const [favBtnText, setFavBtnText] = useState<string>('')

    useEffect(() => {
        let checkFilters = filtersList.length
        let filtersByDate = filtersList.filter(
            (f: any) => f.type === 'date' || f.type === 'daterange'
        )
        if (filtersByDate.length > 0) {
            checkFilters += 1
        }
        setIsFiltersDivisible(
            (checkFilters + 1) % (colWidth ? 12 / colWidth : 6)
        )
    }, [filtersList])

    useEffect(() => {
        if (favouriteFilter?.selectedFavourite)
            setFavBtnText(
                labels?.updateFavourite
                    ? labels.updateFavourite
                    : 'Update Favourite'
            )
        else {
            setFavBtnText(
                labels?.addFavourite ? labels.addFavourite : 'Add Favourite'
            )
            setSelectedFav('')
        }
    }, [favouriteFilter, favouriteFilter?.selectedFavourite])

    const clearFiltersComponent = () => {
        if (clearFiltersVisibility !== undefined && !clearFiltersVisibility) {
            return null
        }
        return (
            <>
                {isFiltersDivisible !== 0 && (
                    <div className="p-col empty-space"></div>
                )}
                <div
                    className={`p-d-flex p-jc-end p-col-${
                        colWidth ? colWidth : 2
                    }`}>
                    <LuxButton
                        icon="times"
                        variant={['outlined']}
                        onClick={() => clearFilters()}
                        text={
                            labels?.clearFilters
                                ? labels.clearFilters
                                : 'Clear Filters'
                        }
                    />
                </div>
            </>
        )
    }

    return (
        <div className={'p-pb-2 p-grid gallery-filters ' + styles.filters}>
            <div
                className={
                    'p-grid gallery-filters-container ' +
                    styles.filtersContainer
                }>
                {favouriteFilter && (
                    <div className="p-col-12 p-d-flex p-jc-start">
                        <LuxButton
                            icon="star-o"
                            onClick={() => setModalOpen(true)}
                            text={favBtnText}
                            disabled={
                                !selectedFav &&
                                favouriteFilter.favouriteFilters.length == 3
                            }
                            variant={['outlined', 'secondary']}
                        />
                        {favouriteFilter.favouriteFilters.length !== 0 && (
                            <LuxFormInput
                                type={INPUT_TYPE.select}
                                optionsList={favouriteFilter.favouriteFilters.map(
                                    (i) => ({
                                        label: i.label,
                                        value: i.label,
                                    })
                                )}
                                clearable={!!selectedFav}
                                placeholder="Favourite Filter Combination"
                                containerClasses="p-py-0 cta-select"
                                onChangeCallback={(e) => {
                                    favouriteFilter.applyFavourite(e.value)
                                    setSelectedFav(e.value)
                                }}
                                value={selectedFav}
                                text="favourite filters"
                            />
                        )}
                        {favouriteFilter.selectedFavourite && (
                            <LuxButton
                                icon="trash"
                                onClick={favouriteFilter.deleteFavourite}
                                tooltip="Delete Favourite"
                                variant={['icon', 'outlined', 'secondary']}
                                tooltipPosition="left"
                            />
                        )}
                    </div>
                )}
                {filtersList.length ? (
                    <>
                        {filtersList.map((f, i) => (
                            <FormInput
                                key={i}
                                colWidth={colWidth ? colWidth : 2}
                                type={f.type}
                                dates={activeDates}
                                onChangeCallback={(e: any) => {
                                    f.onChangeCallback(e)
                                    if (onFiltersBarChange) {
                                        onFiltersBarChange(e, f)
                                    }
                                }}
                                icon={f.icon}
                                optionsList={f.options}
                                value={f.value}
                                disabled={f.disabled}
                                placeholder={f.placeholder}
                                filterable={f.filterable ? f.filterable : false}
                                clearable={f.clearable ? f.clearable : true}
                                {...f.typeProps}
                                additionalProps={{
                                    ...f.additionalProps,
                                }}
                            />
                        ))}
                        {clearFiltersComponent()}
                    </>
                ) : (
                    <strong
                        className="p-col-12 p-my-auto"
                        style={{ textAlign: 'center' }}>
                        No filters to show.
                    </strong>
                )}
            </div>
            {favouriteFilter && (
                <LuxFormDialog
                    icon="star-o"
                    labels={{
                        formTitle: labels?.addFavourite
                            ? labels.addFavourite
                            : 'Add Favourite',
                    }}
                    body={
                        favouriteFilter.selectedFavourite
                            ? `Are you sure you want to update this filters combination?`
                            : 'Enter a name fot this filter configuration.'
                    }
                    formFields={[
                        {
                            type: INPUT_TYPE.text,
                            placeholder: favouriteFilter.selectedFavourite
                                ? favouriteFilter.selectedFavourite
                                : 'Favourite Filter Name',
                            value: newFavName,
                            onChangeCallback: (val: string) =>
                                setNewFavName(val),
                            editable: favouriteFilter.selectedFavourite
                                ? false
                                : true,
                        },
                    ]}
                    visible={modalOpen}
                    onHide={() => {
                        setModalOpen(false)
                        setNewFavName('')
                    }}
                    onSubmit={() =>
                        favouriteFilter.addFavourite(
                            favouriteFilter.selectedFavourite
                                ? favouriteFilter.selectedFavourite
                                : newFavName
                        )
                    }
                />
            )}
        </div>
    )
}

export default FiltersBar
